import OwaSessionStore from './schema/OwaSessionStore';
// tslint:disable-next-line:forbid-import
import * as satcheljs from 'satcheljs';
import { ObservableMap } from 'mobx';
import { TraceableError } from 'owa-trace';

var initialStore: OwaSessionStore = {
    userConfiguration: {},
    connectedAccountsUserConfigurationMap: new ObservableMap({}),
    defaultFolderNameToIdMap: new ObservableMap({}),
    defaultFolderIdToNameMap: new ObservableMap({}),
};

let getStore: () => OwaSessionStore = <any>undefined;
let store: OwaSessionStore = <any>undefined;
try {
    getStore = satcheljs.createStore('owaSessionStore', initialStore);
    store = getStore();
} catch (e) {
    (<TraceableError>e).diagnosticInfo = JSON.stringify({
        c: typeof satcheljs.createStore,
        g: typeof (window as any).__satchelGlobalContext,
        st: typeof satcheljs,
        sk: Object.keys(satcheljs),
    });
    throw e;
}

export default store;
